module.exports = __webpack_public_path__ + "img/cms_client_data.02d75c14.png";